// eslint-disable-next-line max-len
export const API_MY_PROBATIX_ENTRYPOINT: string = process.env.REACT_APP_CORE_API_ENTRYPOINT ? (`${process.env.REACT_APP_CORE_API_ENTRYPOINT}/api-myp`) : 'http://probatix.localhost:8001/api'
export const EXPIRY_OF_STORAGE_MINUTES: string = process.env.REACT_APP_EXPIRY_OF_STORAGE_MINUTES || '5'
export const COOKIE_POLICY_KEY: string = 'COOKIE_POLICY_KEY'
export const EXPIRY_OF_JWT_TOKEN_MINUTES: string = '59'
